/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { useContext } from 'preact/hooks';
import { SortableContext } from './SortableContext';

/**
 * Uses the SortableContext if one is available.
 *
 * @returns The context from the closest provider
 */
export function useSortableContext() {
  return useContext(SortableContext);
}
